export default __webpack_public_path__ + "b9af6300f33706255ea46ed17251da13.svg";